import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// Do not remove store untill the events sdk migration
const store = new Vuex.Store({
    plugins: [],
    modules: {
    }
})

export default store
